import _ from 'underscore';
import * as putil from '@bingads-webui-universal/primitive-utilities';
import { IValidatorMessage, IValidatorOptions } from '../types';

/**
 * Base validator class, provide public interface
 * @param {I18n} i18n - provide callback getString to get error message, will be called
 * with args 'Validation_Base_Field_Not_Valid'
 */
export class Base {
  blockInput: boolean;

  i18n: I18nModel;

  message: IValidatorMessage;

  nullable: boolean;

  isValidValue(_value: any): boolean {
    throw new Error('isValidValue method must be implemented in derived class');
  }

  constructor(i18n: I18nModel) {
    this.blockInput = false;
    this.nullable = false;
    this.i18n = i18n;
    this.message = i18n.getString('Validation_Base_Field_Not_Valid');
  }

  set(options: IValidatorOptions = {}) {
    if (!_.isUndefined(options.blockInput)) {
      this.blockInput = options.blockInput;
    }

    if (!_.isUndefined(options.message)) {
      this.message = options.message;
    }

    if (!_.isUndefined(options.nullable)) {
      this.nullable = options.nullable;
    }

    return this;
  }

  /**
   * Base method to validate value
   * @param value - value to check
   * @returns boolean - whether value is valid
   */
  isValid(value?: any): boolean {
    return (this.nullable && putil.isNil(value)) || this.isValidValue(value);
  }

  /**
   * Base method to validate value; if valid, return undefined, otherwise, return error message
   * @param value - value to validate
   * @returns undefined|string - return undefined if valid; otherwise return error message
   */
  validate(value: any): undefined | IValidatorMessage {
    return this.isValid(value) ? undefined : this.message;
  }
}
